/** tab枚举值（组件名） */
export enum TABS {
  /** 运营中品种 */
  VARIETIES = 'VarietyList',
  /** 预备供货列表 */
  CONFIRM = 'ConfirmSupplyList'
}
/** Tab选项 */
export const TAB_OPTIONS = [
  { label: '运营中品种', value: TABS.VARIETIES }
]
/** 预备供货列表 Tab选项 */
export const CONFIRM_TAB_OPTION = { label: '预备供货列表', value: TABS.CONFIRM }
